// components/common/DesktopRedirect.js

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const DesktopRedirect = () => {
    const location = useLocation();

    useEffect(() => {
        const isMobileDevice = () => {
            // Controlla User-Agent per dispositivi mobili
            const userAgent = navigator.userAgent || navigator.vendor || window.opera;
            const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile|tablet/i;
            const isMobileUserAgent = mobileRegex.test(userAgent);

            // Controlla se ha touch capability (ma non tutti i mobile hanno maxTouchPoints)
            const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

            // Controlla la larghezza dello schermo
            const isSmallScreen = window.innerWidth <= 768;

            // Considera mobile se:
            // 1. User-Agent indica mobile/tablet, OPPURE
            // 2. Ha touch capability E schermo piccolo
            // Ma NON se è un tablet con schermo grande (iPad Pro, ecc.)
            const isTabletLarge = /ipad|tablet/i.test(userAgent) && window.innerWidth > 1024;
            
            return (isMobileUserAgent || (hasTouch && isSmallScreen)) && !isTabletLarge;
        };

        const checkDesktop = () => {
            // Se NON è un dispositivo mobile, reindirizza a desktop
            if (!isMobileDevice()) {
                window.location.href = '/home-desktop.html';
            }
        };

        // Controlla al mount e al resize
        checkDesktop();
        window.addEventListener('resize', checkDesktop);

        return () => {
            window.removeEventListener('resize', checkDesktop);
        };
    }, [location]);

    return null;
};

export default DesktopRedirect;

